export enum FeeDefinitionStatus {
    Active = 'active',
    Inactive = 'inactive',
    Archived = 'archived',
}
